import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import SweetAlert from 'react-bootstrap-sweetalert'

const ProtectedRoute = ({ connected, ecrans, ...data }) => {
    if (connected === data.showWhenConnected) {
        if (ecrans[0] !== '*') {
            if (
                !connected ||
                data.permission === 'demands' ||
                data.title !== 'informartions' ||
                data.title !== 'disconnect' ||
                (connected &&
                    (!data.location ||
                        Object.values(ecrans || {}).includes(
                            data.computedMatch.url
                                // .slice(1)
                                .replace('/:id', '')
                            // .replaceAll('/', '-')
                        ) ||
                        data.path.replaceAll('/', '') === 'change-password'))
            ) {
                return <Route {...data} />
            }
        } else return <Route {...data} />
    } else {
        return (
            <h1 style={{ textAlign: 'center', padding: '3%', fontSize: '3rem' }}>
                Merci de se reconnecter.
            </h1>
        )


    }
    // else {
    //     window.history.back()

    // }
}


ProtectedRoute.propTypes = {
    connected: PropTypes.bool.isRequired,
    ecrans: PropTypes.array,
    location: PropTypes.object,
}

ProtectedRoute.defaultProps = {
    location: null,
    ecrans: [],
}

const mapStateToProps = ({ login }) => ({
    connected: login.connected,
    ecrans: ((login.response || {}).User || {}).ecrans,
})

export default connect(mapStateToProps)(withRouter(ProtectedRoute))
